import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
const Logo = () => {
    const navigate = useNavigate();
    return (_jsx("h1", { className: "logo", onClick: () => navigate("/"), children: "Snort" }));
};
export default Logo;
